import { setNotifInternalFalse } from '../../store/helpers';
import { ACTION_TYPES } from './notificationsActionTypes';

export const INITIAL_STATE = {
  contactList: [],
  contactNames: {},
  curContact: null,
  curNotifDetails: null,
  currentInspector: null,
  error: false,
  errorInfo: {},
  inspectorsList: [],
  notifInternal: {
    loading: false,
    loadingMessage: null,
    retryBackModal: null,
  },
  notifications: null,
  otherNotifList: null,
  permissions: [],
  regCodesList: [],
};

export const notificationsReducer = (state, action) => {
  switch (action.type) {
    case ACTION_TYPES.TRIGGER_ERROR:
      return {
        ...state,
        error: true,
        errorInfo: action.payload,
        notifInternal: setNotifInternalFalse(state.notifInternal),
      };
    case ACTION_TYPES.CLEAR_ERROR:
      return { ...state, error: false, errorInfo: {} };
    case ACTION_TYPES.UPDATE_NOTIF_LIST: {
      const { notifications, ...rest } = action.payload;
      return {
        ...state,
        notifications,
        otherNotifList: rest,
        notifInternal: setNotifInternalFalse(state.notifInternal),
      };
    }
    case ACTION_TYPES.UPDATE_CUR_NOTIF_DETAILS:
      return {
        ...state,
        curNotifDetails: action.payload,
        notifInternal: setNotifInternalFalse(state.notifInternal),
      };
    case ACTION_TYPES.UPDATE_NOTIF_INTERNAL:
      return {
        ...state,
        notifInternal: { ...state.notifInternal, ...action.payload },
      };
    case ACTION_TYPES.UPDATE_CONTACT_LIST:
      return {
        ...state,
        contactList: action.payload,
        notifInternal: setNotifInternalFalse(state.notifInternal),
      };
    case ACTION_TYPES.UPDATE_CUR_CONTACT:
      return {
        ...state,
        curContact: action.payload,
        notifInternal: setNotifInternalFalse(state.notifInternal),
      };
    case ACTION_TYPES.UPDATE_REG_CODES_LIST:
      return {
        ...state,
        regCodesList: action.payload,
        notifInternal: setNotifInternalFalse(state.notifInternal),
      };
    case ACTION_TYPES.UPDATE_CONTACT_NAMES:
      return {
        ...state,
        contactNames: action.payload,
        notifInternal: setNotifInternalFalse(state.notifInternal),
      };
    case ACTION_TYPES.UPDATE_STANDBY_INSPECTORS_LIST:
      return {
        ...state,
        inspectorsList: action.payload,
        notifInternal: setNotifInternalFalse(state.notifInternal),
      };
    case ACTION_TYPES.UPDATE_CUR_STANDBY_INSPECTOR:
      return {
        ...state,
        currentInspector: action.payload,
        notifInternal: setNotifInternalFalse(state.notifInternal),
      };
    case ACTION_TYPES.UPDATE_PERMISSIONS:
      return {
        ...state,
        permissions: action.payload,
      };
    default:
      return state;
  }
};
